import Image from 'next/image';
import { IParsedImage, TMediaFit } from '@components/typescript';
import useImageSources from '@hooks/useImageSources';
import styles from '@components/ImageSource/ImageSource.styles';
import getImageQuality from '@utils/getImageQuality';
import { useResponsive } from '@features/responsive';
import getCurrentDevice from '@utils/getCurrentDevice';
import GetImageAlt from '@utils/getImageAlt';
type PropsType = {
  imageSources: IParsedImage;
  alt: string;
  sizes: string;
  onLoad?: (loadingComplete: boolean) => void;
  priority?: boolean;
  objectFit?: TMediaFit;
};
const ImageSource = ({
  imageSources,
  alt,
  sizes,
  onLoad = () => null,
  priority = false,
  objectFit = 'cover'
}: PropsType) => {
  const {
    currentBreakpoint
  } = useResponsive();
  const {
    getSrcs
  } = useImageSources(imageSources);
  const renderImage = () => {
    const {
      imageSrc,
      blurSrc
    } = getSrcs(getCurrentDevice(currentBreakpoint));
    const handleLoadComplete = () => {
      if (onLoad) onLoad(true);
    };
    if (!imageSrc) return null;
    return <Image priority={priority} key={`image-${Math.random()}`} alt={GetImageAlt(imageSources.image) || alt} sx={styles.image} src={imageSrc} fill quality={getImageQuality()} sizes={sizes} blurDataURL={blurSrc} placeholder={blurSrc ? 'blur' : 'empty'} onLoad={() => handleLoadComplete()} objectFit={objectFit}
    // loading={priority ? 'eager' : 'lazy'}
    />;
  };
  return <>{renderImage()}</>;
};
export default ImageSource;